import Box from "@material-ui/core/Box";
import Checkbox from "@material-ui/core/Checkbox";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import React from "react";
import { HasTestId, PlainFunctionComponent } from "../../types";

export type SelectableOptionState = "checked" | "unchecked" | "indeterminate";

// use `DOMAttributes` to get all the events
export interface SelectableOptionProps extends Omit<React.HTMLAttributes<HTMLSpanElement>, "children">, HasTestId {
    label: React.ReactNode;
    selected: SelectableOptionState;
}

export const SelectableOption: PlainFunctionComponent<SelectableOptionProps & React.RefAttributes<HTMLSpanElement>> = React.forwardRef(
    ({ className, label, selected, testId, ...props }, ref) => {
        const classes = useStyles();
        return (
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore -- `ref` is working but not part of `BoxProps`; ignore as only adjusted for Material-UI v5, see https://github.com/mui-org/material-ui/issues/17010#issuecomment-724187064.
            <Box className={className} component="span" data-testid={testId} ref={ref} {...props}>
                <Checkbox checked={selected === "checked"} className={classes.optionCheckbox} indeterminate={selected === "indeterminate"} />
                {label}
            </Box>
        );
    },
);

const useStyles = makeStyles(
    createStyles({
        optionCheckbox: {
            margin: "-6px 0px -6px -6px", // use `margin` to keep `padding` for hover but reduce size to have option line of `32px`
            padding: 6, // `padding` cannot be `0` because affects hover animation
        },
    }),
);
